export default {
  placeholder: 'Ein Einheitensystem auswählen',
};
